// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","644":"ForumFirst","656":"ForumSecord"}[chunkId] + "." + {"443":"cbc961d6","644":"2e37b30e","656":"b4da4b39"}[chunkId] + ".css";
};